import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { RotateCcw, AlertTriangle } from 'lucide-react';

interface RevertCancelModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (revertPayments: boolean) => void;
  isLoading?: boolean;
  cancelledPaymentsCount?: number;
}

export const RevertCancelModal: React.FC<RevertCancelModalProps> = ({
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
  cancelledPaymentsCount = 0
}) => {
  const [revertPayments, setRevertPayments] = useState(true);

  const handleConfirm = () => {
    onConfirm(revertPayments);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <RotateCcw className="h-5 w-5 text-primary" />
            Reverter Cancelamento
          </DialogTitle>
          <DialogDescription>
            Esta ação irá reativar o contrato cancelado.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="flex items-center gap-3 p-3 bg-amber-50 dark:bg-amber-900/20 rounded-lg border border-amber-200 dark:border-amber-800">
            <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-400 flex-shrink-0" />
            <p className="text-sm text-amber-800 dark:text-amber-200">
              O status do deal será alterado de "Cancelado" para "Ativo".
            </p>
          </div>

          {cancelledPaymentsCount > 0 && (
            <div className="flex items-start gap-3">
              <Checkbox
                id="revertPayments"
                checked={revertPayments}
                onCheckedChange={(checked) => setRevertPayments(checked === true)}
              />
              <div className="space-y-1">
                <Label htmlFor="revertPayments" className="cursor-pointer">
                  Reativar pagamentos cancelados
                </Label>
                <p className="text-xs text-muted-foreground">
                  {cancelledPaymentsCount} pagamento{cancelledPaymentsCount > 1 ? 's' : ''} cancelado{cancelledPaymentsCount > 1 ? 's' : ''} será{cancelledPaymentsCount > 1 ? 'ão' : ''} reativado{cancelledPaymentsCount > 1 ? 's' : ''} como "Pendente"
                </p>
              </div>
            </div>
          )}
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Revertendo...' : 'Confirmar Reversão'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RevertCancelModal;
